import { Component, Input, OnInit, Output, EventEmitter, Injector } from '@angular/core';
import { profileQualificationI } from 'app/core/interfaces/layout';
import { SecretaryInterface, languageI, qualificationI } from 'app/core/interfaces/secretary';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { SecretaryService } from 'app/core/http/services/secretary.service';
import { Qualification } from 'app/core/interfaces/qualification';
import { Communication } from 'app/core/interfaces/communication';

@Component({
  selector: 'secretary-qualification-form',
  templateUrl: './secretary-qualification-form.component.html',
  styleUrls: ['./secretary-qualification-form.component.scss']
})
export class SecretaryQualificationFormComponent extends BaseComponent implements OnInit {

  @Input() public qualifications: Qualification[] = [];
  @Input() public courses: Qualification[] = [];
  @Input() public languages: Communication[] = [];
  @Output() onUpdate = new EventEmitter<profileQualificationI>();

  @Input() secretary: SecretaryInterface = <SecretaryInterface>{};
  @Input() mode = 'CREATE';

  @Output() onUpdateSecretary = new EventEmitter<any>();

  public titleLanguages = 'Idiomas';
  public titleQualifications = 'Qualificações';
  public titleCourses = 'Cursos/Certificados';
 
  
  private secretaryId = "";


  @Input() actor: string = ''; 

  constructor( 
    private secretaryService: SecretaryService,
    private injector: Injector,
    ){super(injector);
  }


  ngOnInit(): void {

      if (this.mode == 'CREATE') {
        this.secretaryId = this.secretary.secretaries_id
        
      }

      if (
        this.mode == 'UPDATE' &&
        localStorage.getItem('isFirstAccess') == 'false'
      )
        this.getSecretary();

     
      this.formatValues();    
  }

  private getSecretary() {

    const secretary_id = this.auth.getCurrentUser().user.id;

    this.secretaryService.showNew(secretary_id)
      .subscribe({
        next: (secretary: SecretaryInterface) => {
          this.secretary = secretary
      
          this.qualifications = this.secretary.qualifications
          this.courses = this.secretary.certificates
          this.languages = this.secretary.communication

          this.onUpdateSecretary.emit(secretary)

        },
        error: err => {
          console.log(err) // Posteriormente, adicionar um toastr aqui
        }
      })
  }

  onChangeForm() {
    const retorno: profileQualificationI = {
      qualifications: this.qualifications,
      courses: this.courses,
      communication : this.languages
    }
    this.onUpdate.emit(retorno);
  }

  addQualification() {
    if (!this.qualifications) {
      this.qualifications = [];
    }

    this.qualifications.unshift({
     name: "",
     instituition: "",
     dateConclusion: "",
     level: "",
     type: "QUALIFICATION",
    })
  }

  addCourse() {
    if (!this.courses) {
      this.courses = [];
    }
    this.courses.unshift({
      name: "",
      instituition: "",
      dateConclusion: "",
      level: "CURSO",
      type: "COURSE",
    })
  }

  addLanguage() {

    if (!this.languages) {
      this.languages = [];
    }

    this.languages.unshift({
      language: '',
      preferred: false,
      proficiency: ''
    })
  }

  formatValues() {
    if (this.qualifications && this.qualifications.length > 0) {
      this.qualifications.forEach((item: Qualification) => 
      item.dateConclusion = item.dateConclusion ? this.layout.getDatePtFormat(item.dateConclusion) : ''
      );
    }
    if (this.courses && this.courses.length > 0) {
      this.courses.forEach((item: Qualification) => 
      item.dateConclusion = item.dateConclusion ? this.layout.getDatePtFormat(item.dateConclusion) : ''
      );
    }
  }

  save(){

    this.loading = true; 

    this.showSuccessMessage = false;
    this.showErrorMessage = false;
    
    const secretary_id = this.auth.getCurrentUser().user.id;

    const secretaryFormValues = {
      ...this.secretary,
      ...this.qualifications,
      ...this.courses,
      ...this.languages
    }

    this.secretaryService.updateNew(secretary_id, secretaryFormValues)
    .subscribe({
      next: (secretary: any) => {
        this.secretary = secretary

        this.loading = false; 
        this.showErrorMessage = false;
        this.showSuccessMessage = true;

        this.onUpdateSecretary.emit(secretary)

      },
      error: err => {
        console.log(err) // Posteriormente, adicionar um toastr aqui
        this.loading = false; 

      }
    })
  } 

  objectIsEmpty(obj?: any): boolean {

    if (obj == null) return true;

    if (Array.isArray(obj)) {
      return obj.length === 0;
    }

    if (typeof obj === 'object') {
      const values = Object.values(obj);
      return values.every(
        v =>
          v === null ||
          v === undefined ||
          (typeof v === 'string' && v.trim() === '')
      );
    }

    return false;
  }

  allowOnlyLetters(event: KeyboardEvent): void {
    const inputChar = event.key;

    if (!/^[a-zA-ZÀ-ÿ\s]$/.test(inputChar)) {
      event.preventDefault();
    }
  }
}